// extracted by mini-css-extract-plugin
export default {"root":"TabSwitcher_root__e03Ty","tab":"TabSwitcher_tab__JvdMI","tabActive":"TabSwitcher_tabActive__ojtOd"};